// Mock data for Residential Support Ltd

export const company = {
  name: 'Residential Support Ltd',
  tagline: 'Your one-stop outsourcing partner for letting agents.',
  phone: '03333 445 336',
  email: 'info@residentialsupport.co.uk',
  address: '20 Allandale Road, Leicester LE2 2DA',
  hours: 'Mon–Fri  9am – 5pm',
};

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'How it works', to: '/how-it-works' },
  { label: 'About', to: '/about' },
  { label: 'Blog', to: '/blog' },
  { label: 'Contact', to: '/contact' },
];

export const services = [
  {
    id: 'inventories',
    icon: 'ClipboardList',
    title: 'Check-in Inventory',
    short: 'Photo-rich, deposit-dispute-ready inventory reports.',
    description:
      'Detailed room-by-room write-up with date-stamped photography, meter readings and smoke alarm checks. Delivered to your inbox in working hours.',
    image:
      'https://images.unsplash.com/photo-1630699144339-420f59b4747b?fm=jpg&q=60&w=900&auto=format&fit=crop',
    from: 59,
  },
  {
    id: 'viewings',
    icon: 'KeyRound',
    title: 'Accompanied Viewings',
    short: 'Local viewers who run viewings and report back to your branch.',
    description:
      'Trained UK viewers attend on your behalf, run a friendly, professional viewing and pass any offer signals back to your branch so you can pick up the negotiation.',
    image:
      'https://images.pexels.com/photos/8815820/pexels-photo-8815820.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    from: 49,
  },
  {
    id: 'photography',
    icon: 'Camera',
    title: 'Pro Photography & Floor Plans',
    short: 'Wide-angle photography plus a laser-measured floor plan in one visit.',
    description:
      'Wide-angle HDR photography paired with an accurate 2D floor plan, exported ready for Rightmove and Zoopla.',
    image:
      'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&w=900&q=80',
    from: 69,
  },
  {
    id: 'checkout',
    icon: 'ClipboardCheck',
    title: 'Check-out Inventory',
    short: 'Dilapidation report at the end of a tenancy, ready for deposit return.',
    description:
      'Side-by-side comparison against the original check-in. Wear-and-tear judgements, photographic evidence and a clear charge schedule for the deposit scheme.',
    image:
      'https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=900&q=80',
    from: 69,
  },
];

export const stats = [
  { value: '12,400+', label: 'Properties serviced' },
  { value: '480', label: 'Agencies partnered' },
  { value: '98%', label: 'On-time attendance' },
  { value: '4.9/5', label: 'Average review score' },
];

export const steps = [
  {
    step: '01',
    icon: 'MousePointerClick',
    title: 'Place an order',
    text: 'Book online in under a minute.',
  },
  {
    step: '02',
    icon: 'CalendarCheck',
    title: 'We schedule',
    text: 'A vetted local specialist is assigned to your job.',
  },
  {
    step: '03',
    icon: 'ClipboardCheck',
    title: 'Job completed',
    text: 'Reports, photos and certificates are uploaded to your dashboard.',
  },
  {
    step: '04',
    icon: 'BadgeCheck',
    title: 'You get paid back time',
    text: 'Spend the saved hours winning new instructions, not chasing diaries.',
  },
];

export const testimonials = [
  {
    name: 'Olivia Hartman',
    role: 'Lettings Director, Northwood London',
    text:
      'Residential Support has been the single biggest productivity boost our branch has seen in five years. Reports come back quickly — every time.',
    avatar: 'https://i.pravatar.cc/120?img=47',
  },
  {
    name: 'James Whitford',
    role: 'Director, Whitford & Co Estate Agents',
    text:
      'We outsourced viewings and never looked back. The team feel like an extension of our own staff and the feedback we get is incredibly detailed.',
    avatar: 'https://i.pravatar.cc/120?img=12',
  },
  {
    name: 'Priya Sharma',
    role: 'Operations Manager, Citystay',
    text:
      'Inventories now flow straight into our system and our property managers focus on tenants, not paperwork. The reports are genuinely the best we have seen.',
    avatar: 'https://i.pravatar.cc/120?img=32',
  },
];

export const pricingPlans = [
  {
    name: 'Pay as you go',
    price: '£0',
    cadence: 'no monthly fee',
    highlight: false,
    features: [
      'Order any service on demand',
      'Fast booking confirmation',
      'Web dashboard included',
      'Email & phone support',
    ],
    cta: 'Start ordering',
  },
  {
    name: 'Partner',
    price: '£149',
    cadence: 'per branch / month',
    highlight: true,
    features: [
      'Up to 10% discount on every service',
      'Dedicated account manager',
      'Priority scheduling',
      'Quarterly performance reviews',
    ],
    cta: 'Become a partner',
  },
  {
    name: 'Enterprise',
    price: 'Bespoke',
    cadence: 'multi-branch agencies',
    highlight: false,
    features: [
      'Custom SLAs',
      'National coverage guarantee',
      'Quarterly business reviews',
      'Bespoke reporting & analytics',
      'Onboarding & training',
    ],
    cta: 'Talk to sales',
  },
];

export const faqs = [
  {
    q: 'Which areas of the UK do you cover?',
    a: 'We cover all major UK regions including London, the Home Counties, the Midlands, the North West, Yorkshire and Scotland. Coverage is expanding monthly — get in touch to confirm your postcode.',
  },
  {
    q: 'How quickly can you attend a property?',
    a: 'For most postcodes we can attend swiftly thanks to our national network of local clerks. Tell us about a tight turnaround when ordering and we will schedule a clerk who can fit it in.',
  },
  {
    q: 'Are your clerks insured?',
    a: 'Every clerk on our network carries full Public Liability and Professional Indemnity insurance up to £2m. Certificates are available on request.',
  },
  {
    q: 'How do you handle keys?',
    a: 'We can collect from your office, a secure key safe or directly from the tenant. All key movements are logged in the dashboard with photographic evidence.',
  },
];

export const partners = [
  'NORTHWOOD', 'CITYSTAY', 'WHITFORD & CO', 'PROPERTIQ', 'LONDON LETS', 'OAKFIELD', 'GRIFFIN HOMES'
];

export const hero = {
  image:
    'https://images.unsplash.com/photo-1651964723487-722c8acc07d6?auto=format&fit=crop&w=1200&q=80',
  side:
    'https://images.unsplash.com/photo-1741156386380-0236c72eb6f9?auto=format&fit=crop&w=600&q=80',
};
